import { routePaths } from './basePaths';
import { undercarriagePaths } from './undercarriage.routes';
import { bucketPaths } from './bucket.routes';
import { InspectionTableOfContentsScreen } from '../pages/InspectionTableOfContentsScreen';
import { OperatingHoursScreen } from '../pages/inspections/common/OperatingHoursScreen';
import { MachinePhotoScreen } from '../pages/inspections/common/MachinePhoto';
import { SubmittedInspectionGuard } from '../components/templates/SubmittedInspectionGuard';

/**
 * The screens of one Inspection, shared with the read-only routing integration tests.
 * The editing screens sit under one guard, so moving between them keeps one guard mounted.
 */
export const inspectionRoutes = [
  {
    path: routePaths.InspectionBasePath,
    children: [
      {
        path: routePaths.InspectionBasePath + '/review',
        lazy: async () => {
          const { ReviewScreen } = await import('../pages/ReviewScreen');
          return {
            element: <ReviewScreen />,
          };
        },
      },
      {
        path: routePaths.InspectionBasePath + '/complete',
        lazy: async () => {
          const { CompletedInspectionScreen } =
            await import('../pages/CompletedInspectionScreen');
          return {
            element: <CompletedInspectionScreen />,
          };
        },
      },
      {
        // The sending screen: it submits the Inspection and stays open while it is sent.
        path: routePaths.InspectionBasePath + '/submit',
        lazy: async () => {
          const { SubmitScreen } = await import('../pages/SubmitScreen');
          return {
            element: <SubmitScreen />,
          };
        },
      },
    ],
  },
  {
    element: <SubmittedInspectionGuard />,
    children: [
      {
        path: routePaths.InspectionBasePath,
        children: [
          {
            path: routePaths.InspectionBasePath,
            element: <InspectionTableOfContentsScreen />,
          },
          {
            path: routePaths.InspectionDate,
            lazy: async () => {
              const { InspectionDateScreen } =
                await import('../pages/inspections/common/InspectionDateScreen');
              return {
                element: <InspectionDateScreen />,
              };
            },
          },
          {
            path: routePaths.InspectionBasePath + '/asset',
            children: [
              {
                path: routePaths.ExecutiveSummary,
                lazy: async () => {
                  const { ExecutiveSummaryScreen } =
                    await import('../pages/ExecutiveSummaryScreen');
                  return {
                    element: <ExecutiveSummaryScreen />,
                  };
                },
              },
              {
                path: routePaths.OperationHours,
                element: <OperatingHoursScreen />,
              },
              {
                path: 'machine-photo',
                element: <MachinePhotoScreen />,
              },
            ],
          },
        ],
      },
      {
        path: routePaths.InspectionBasePath + '/undercarriage',
        children: undercarriagePaths,
      },
      {
        path: routePaths.InspectionBasePath + '/bucket',
        children: bucketPaths,
      },
    ],
  },
];
